import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Terms of Service — summary placeholder. Replace with counsel-reviewed documents before scaling sales.
 */
export default function LegalTerms() {
  return (
    <div className="min-h-screen bg-gray-900 text-gray-200">
      <div className="max-w-3xl mx-auto px-4 py-12 md:py-16">
        <Link to="/" className="text-cyan-400 hover:text-cyan-300 text-sm mb-8 inline-block">
          ← Back to home
        </Link>
        <h1 className="text-3xl md:text-4xl font-bold text-white mt-4 mb-2">Terms of Service</h1>
        <p className="text-gray-400 text-sm mb-10">Last updated: March 2026</p>

        <div className="space-y-6 text-sm md:text-base leading-relaxed">
          <p className="text-amber-200/90 bg-amber-900/20 border border-amber-700/40 rounded-lg p-4">
            Appify.AI provides a demo environment and optional professional setup for production voice agents.
            These terms are a starting point for transparency; have them reviewed by a qualified attorney for your
            jurisdictions (including the United States, United Kingdom, and South Africa) before relying on them in
            high-value contracts.
          </p>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-3">1. Services</h2>
            <p>
              We may offer (a) a self-service demo of an AI voice assistant accessible in your browser, and (b)
              optional consulting and technical configuration for production use, including phone numbers, call routing,
              and integrations. Production scope, timelines, and fees are agreed separately (for example by proposal,
              statement of work, or invoice).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-3">2. Demo vs production</h2>
            <p>
              The demo is for evaluation. A production deployment may depend on third parties (telephony carriers,
              your IT policies, and platform availability). We do not guarantee uninterrupted service or specific
              business outcomes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-3">3. Acceptable use</h2>
            <p>
              You agree not to misuse the service, including attempting to interfere with other customers, violate
              applicable law, or use the service to harass, defraud, or harm others. You are responsible for how you
              use AI-generated content and voice interactions with your callers.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-3">4. Fees</h2>
            <p>
              Where fees apply, they are as quoted on an invoice or checkout. Unless otherwise stated, fees are
              non-refundable once work has started, subject to mandatory consumer rights in your region.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-3">5. Limitation of liability</h2>
            <p>
              To the maximum extent permitted by law, Appify.AI’s total liability arising from these terms or the
              service is limited to the amount you paid us for the service in the twelve (12) months before the claim.
              We are not liable for indirect, incidental, or consequential damages.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-3">6. Contact</h2>
            <p>
              Questions:{' '}
              <a href="mailto:admin@appifyai.com" className="text-cyan-400 hover:underline">
                admin@appifyai.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
